var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0091 14.0013C17.6924 14.0013 20.6758 11.018 20.6758 7.33464C20.6758 3.6513 17.6924 0.667969 14.0091 0.667969C10.3258 0.667969 7.34245 3.6513 7.34245 7.33464C7.34245 11.018 10.3258 14.0013 14.0091 14.0013ZM14.0091 17.3346C9.55911 17.3346 0.675781 19.568 0.675781 24.0013V25.668C0.675781 26.5846 1.42578 27.3346 2.34245 27.3346H25.6758C26.5924 27.3346 27.3424 26.5846 27.3424 25.668V24.0013C27.3424 19.568 18.4591 17.3346 14.0091 17.3346Z",
    fill: "#FFC400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6bad5ecf0b483964c16904a742b749af.svg";
export { ForwardRef as ReactComponent };